module.exports = __webpack_public_path__ + "static/media/innerspaces1.c947208f.jpg";